<template>
  <div class="container-fluid" style="margin-top: 0px; margin-bottom: 100px; min-height: 750px;">
   <div class="row">
     <b-col sm="3">
      <b-card class="">
        <div class="row">
          <!--<div class="col-3" style="font-size: 4rem;">
           <b-icon-list-ol font-scale="" class="border rounded bg-success p-2 "></b-icon-list-ol>
          </div>-->
          <b-col sm="">
            <h6 class="text-center mt-1" style="font-weight:bolder; color:#1ce007"><router-link :to="{name: 'outcomes'}" style="color:#1ce007">Total UNEA Outcomes</router-link></h6>
            <div class="info-box-content mt-3">
            <h6 class="text-center" style="font-weight:bold;">{{outcomes}}</h6>
            </div>
          </b-col>
        </div>
      </b-card>
     </b-col>
     <b-col sm="3">
      <b-card class="">
        <div class="row">
          <b-col sm="">
            <h6 class="text-center mt-1" style="font-weight:bolder; color:#17a2b8;"><router-link :to="{name: 'reports'}" style="color:#17a2b8;">Total UNEA Reports</router-link></h6>
            <div class="info-box-content mt-3">
            <h6 class="text-center" style="font-weight:bold;">{{reports}}</h6>
            </div>
          </b-col>
        </div>
      </b-card>
     </b-col>
     <b-col sm="3">
      <b-card class="">
        <div class="row">
          <b-col sm="">
            <h6 class="text-center mt-1" style="font-weight:bolder; color:#e3d409"><router-link :to="{name: 'reports'}" style="color:#e3d409">Total PoW Reports</router-link></h6>
            <div class="info-box-content mt-3">
            <h6 class="text-center" style="font-weight:bold;">{{pow_reports}}</h6>
            </div>
          </b-col>
        </div>
      </b-card>
     </b-col>
     <b-col sm="3">
      <b-card class="">
        <div class="row">
          <b-col sm="">
            <h6 class="text-center mt-1" style="font-weight:bolder; color: #e30909"><router-link :to="{name: 'pow'}" style="color:#e30909">Total PoW Pdfs</router-link></h6>
            <div class="info-box-content mt-3">
            <h6 class="text-center" style="font-weight:bold;">{{pow_files}}</h6>
            </div>
          </b-col>
        </div>
      </b-card>
     </b-col>
  </div>
  <div class="row mt-4">
    <b-col sm="">
     <b-card no-body class="mb-1" header-bg-variant="transparent">
          <template v-slot:header >
            <b-row>
            <b-col sm="6">
            <h5 class="mb-0">Outcomes by Sub-programmes</h5>
            </b-col>
            <b-col sm="6" class="text-right">
            <div class="row" >
              <b-col sm="8">
               <h5 class="mb-0">Outcomes by Status</h5>
              </b-col>
              <b-col sm="4">
              <b-button variant="info" size="sm" style="font-weight:bold;" href="#" role="tab" v-b-toggle.accordion-1>---</b-button>
              </b-col>
            </div>
            </b-col>
            </b-row>
          </template>
        <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
        <b-card-body >
          <div class="row mb-3">
            <b-col sm="6" class="" style="text-align:center">
              <p class="text-center">
                <strong></strong>
              </p>
              <b-row class="ml-5">
                <apexchart v-if="loaded" width="600" height="" type="bar" class="text-center"
                :options="visitorOptions" :series="visitorSeries">
                </apexchart>
              </b-row>
            </b-col>
            <b-col sm="6" class="mt-5">
               <p class="text-center">
                <strong></strong>
              </p>
              <div v-for="item in status"  :key="item.id" class="row mb-3">
                <div class="col-sm-3"><router-link  :to="{name: 'outcomes', query: {filterValue: item.status_type, filterBy: 'status_model.status_type'}}"
                                          style="font-weight:normal; font-size:18px;"> {{ item.status_type }} </router-link>:</div>
                <div class="col-sm-9 pt-1">
                  <span class="float-right mt-n2 ml-2">{{item.outcomes}}/{{outcomes}}</span>
                  <b-progress variant="warning" :value="item.outcomes" :key="item.id" ></b-progress>
                </div>
              </div>
            </b-col>
          </div>
        </b-card-body>
        </b-collapse>
        <template v-slot:footer>
        <div class="row">
          <div class="col-sm-6 col-6">
             <div class="description-block border-right" style="text-align:center">
              <span class="description-percentage"></span>
              <h5 class="description-header"></h5>
              <span class="description-percentage"></span>
            </div>
          </div>
          <div class="col-sm-6 col-6">
             <div class="description-block"  style="text-align:center">
              <span class="description-percentage"></span>
              <h5 class="description-header"></h5>
              <span class="description-percentage"></span>
            </div>
          </div>
        </div>
        </template>
      </b-card>
    </b-col>
  </div>
  <div class="row mt-4">
    <b-col sm="8">
       <b-card no-body class="mb-1" header-bg-variant="transparent">
         <template v-slot:header >
            <b-row>
            <b-col sm="6">
            <h5 class="mb-0" style="">Outcomes by Types</h5>
            </b-col>
            <b-col sm="6" class="text-right">
            <div >
              <b-button variant="info" size="sm" style="font-weight:bold;" href="#" role="tab" v-b-toggle.accordion-2>---</b-button>
            </div>
            </b-col>
            </b-row>
          </template>
          <b-collapse id="accordion-2" visible accordion="my-accordion2" role="tabpane2">
          <b-card-body >
          <b-row class="text-center">
            <b-col class="text-center">
            <p class="text-center">
                <strong></strong>
              </p>
            </b-col>
          </b-row>
          <b-row class="justify-content-center align-items-center">
                <apexchart v-if="loaded" width="400" type="pie" 
                :options="catOptions" :series="catSeries">
                <router-link></router-link>
                </apexchart>
          </b-row>
          </b-card-body>
          </b-collapse>
       </b-card>
       <b-row>
         <div class="col-md-12">
        <b-card no-body class="mb-1 mt-4" header-bg-variant="transparent">
      <template v-slot:header >
            <b-row>
            <b-col sm="6">
            <h5 class="mb-0" style="">Outcomes by Assembly</h5>
            </b-col>
            <b-col sm="6" class="text-right">
            <div >
              <b-button variant="info" size="sm" style="font-weight:bold;" href="#" role="tab" v-b-toggle.accordion-4>---</b-button>
            </div>
            </b-col>
            </b-row>
          </template>
           <b-collapse id="accordion-4" visible accordion="my-accordion4" role="tabpane4">
        <b-card-body>
          <b-row class="ml-5">
            <apexchart v-if="loaded" width="500" type="line" 
            :options="pvOptions" :series="pvSeries"></apexchart>
          </b-row>
        </b-card-body>
           </b-collapse>
        </b-card>
            </div>
       </b-row>
    </b-col>
    <b-col sm="4">
    <b-card no-body class="mb-1" header-bg-variant="transparent">
      <template v-slot:header >
            <b-row>
            <b-col sm="6">
            <h5 class="mb-0" style="">Outcomes by SDGs</h5>
            </b-col>
            <b-col sm="6" class="text-right">
            <div >
              <b-button variant="info" size="sm" style="font-weight:bold;" href="#" role="tab" v-b-toggle.accordion-3>---</b-button>
            </div>
            </b-col>
            </b-row>
          </template>
          <b-collapse id="accordion-3" visible accordion="my-accordion3" role="tabpane3">
          <b-card-body>
            <table class="table table-bordered small">
                    <thead>
                    <th>SDGs</th>
                    <th>Outcomes</th>
                    </thead>

                    <tbody>
                    <tr v-for="item in sdgs" :key="item.id">
                        <td>
                            <router-link  :to="{name: 'outcomes', query: {filterValue: item.indicator_name, filterBy: 'sdg_outcome'}}"
                                          style="font-weight:normal; font-size:13px;"> {{ item.indicator_name }} </router-link>
                        </td>
                        <td>
                            {{ item.outcomes}}
                        </td>
                    </tr>
                    </tbody>
                </table>
          </b-card-body>
          </b-collapse>
    </b-card>
    </b-col>
  </div>
</div>
</template>
<script>
export default {
        name: 'Home',
        data() {
            return {
                apiUrl: process.env.VUE_APP_API_PATH,
                status: [],
                types: [],
                outcomes: 0,
                reports: 0,
                loaded: false,
                pvOptions: null,
                pvSeries: null,
                catOptions: null,
                catSeries: null,
                visitorOptions: null,
                visitorSeries: null,
                bars: [
                  { variant: 'success'},
                  { variant: 'info'},
                  { variant: 'warning'},
                  { variant: 'danger'},
                ],
            }
        },
        mounted() {
            this.fetchData();
        },
        methods: {
            fetchData() {
                let url = this.apiUrl;
                fetch(url + '/dashboard')
                    .then(res => res.json())
                    .then(res => {
                        this.status = res["status"];
                        this.types = res["types"];
                        this.outcomes = res["outcomes"];
                        this.reports = res["reports"];
                        this.pows = res["pows"];
                        this.pow_reports = res["pow_reports"];
                        this.pow_files = res["pow_files"];
                        this.sdgs = res["sdgs"];
                    })
        }
    },
    async created() {
    let resp = await fetch(
      "https://staging1.unep.org/shadrackkirui/new_unea/api/reporting/dashboard"
    );
    let data = await resp.json();

    let pageViews = data.assembly;
    let pageViewsByCategory = data.types;
    let visitors = data.pows;

    this.pvOptions = {
      xaxis: {
        categories: []
      }
    };

    this.pvSeries = [
      {
        name: "Outcomes",
        data: []
      }
    ];

    pageViews.forEach(pv => {
      this.pvOptions.xaxis.categories.push(pv.assembly_code);
      this.pvSeries[0].data.push(pv.outcomes);
    });

    this.catOptions = {
      labels: []
    };

     this.catSeries = [];

    for (let cat in pageViewsByCategory) {
      this.catOptions.labels.push(pageViewsByCategory[cat]['outcome_type']);
      this.catSeries.push(pageViewsByCategory[cat]['outcomes']);
    }

    this.visitorOptions = {
      chart: {
        stacked: true
      },
      xaxis: {
        categories: []
      }
    };

    this.visitorSeries = [
      {
        name: "outcomes",
        data: []
      }
    ];

    visitors.forEach(v => {
      this.visitorOptions.xaxis.categories.push(v.pow);

      this.visitorSeries[0].data.push(v.outcomes);
    });

    this.loaded = true;
  }

}
</script>
<style>

</style>